import { getFunctions, httpsCallable } from 'firebase/functions';
import {
  getFirestore,
  collection,
  addDoc,
  updateDoc,
  getDoc,
  doc,
  deleteDoc,
} from 'firebase/firestore';
import app from './lib/firebase-app';
import './lib/nav';

const funcs = getFunctions(app);
const db = getFirestore(app);

const ordersColRef = collection(db, 'orders');

const allProducts = {};
const orderProducts = {};

const url = new URL(window.location.href);
const orderId = url.searchParams.get('orderId');
// first-name, last-name, email, phone, address, city, state, zip-code, pickup-date, pickup-time, products

function populateOrderProducts() {
  const productTableBody = document.querySelector('#products tbody');
  const productList = new DocumentFragment();
  const products = Object.keys(orderProducts);
  let total = 0.0;
  products.forEach((product) => {
    const quantity = parseInt(orderProducts[product].quantity, 10);
    const price = parseFloat(orderProducts[product].price, 10);
    const row = document.createElement('tr');
    const nameCell = document.createElement('td');
    nameCell.innerText = product;
    const quantityCell = document.createElement('td');
    quantityCell.innerText = quantity;
    const unitPriceCell = document.createElement('td');
    unitPriceCell.innerText = `$${price.toLocaleString(undefined, {
      minimumFractionDigits: 2,
    })}`;
    const priceCell = document.createElement('td');
    priceCell.innerText = `$${(price * quantity).toLocaleString(undefined, {
      minimumFractionDigits: 2,
    })}`;

    total += price * quantity;

    const actionsCell = document.createElement('td');
    const editAction = document.createElement('button');
    editAction.className =
      'btn-floating btn-small waves-effect waves-light blue';
    editAction.innerHTML = '<i class="material-icons">edit</i>';

    editAction.addEventListener('click', (e) => {
      e.preventDefault();
      const productSelector = document.querySelector('#product-selector');
      const { input } = M.FormSelect.getInstance(productSelector);
      input.value = product;
      productSelector.value = product;
      document.querySelector('#product-quantity').value = quantity;
      const modal = document.querySelector('#add-product-modal');
      M.Modal.getInstance(modal).open();
    });

    const deleteAction = document.createElement('button');
    deleteAction.className =
      'btn-floating btn-small waves-effect waves-light red';
    deleteAction.innerHTML = '<i class="material-icons">delete</i>';

    deleteAction.addEventListener('click', (e) => {
      e.preventDefault();
      delete orderProducts[product];
      populateOrderProducts();
    });

    actionsCell.appendChild(editAction);
    actionsCell.appendChild(deleteAction);

    row.appendChild(nameCell);
    row.appendChild(quantityCell);
    row.appendChild(unitPriceCell);
    row.appendChild(priceCell);
    row.appendChild(actionsCell);
    productList.appendChild(row);
  });
  const totalLine = document.createElement('tr');
  totalLine.innerHTML = `
    <td><strong>Total</strong></td>
    <td></td>
    <td></td>
    <td><strong>$${total.toLocaleString(undefined, {
      minimumFractionDigits: 2,
    })}</strong></td>
    <td></td>
    `;
  productList.appendChild(totalLine);
  productTableBody.replaceChildren(productList);
}

populateOrderProducts();

async function populateModalProducts() {
  try {
    const getProducts = httpsCallable(funcs, 'getProducts');
    const result = await getProducts();
    const { products } = result.data;
    const selectElements = new DocumentFragment();
    const instructionOption = document.createElement('option');
    instructionOption.value = '';
    instructionOption.setAttribute('disabled', '');
    instructionOption.setAttribute('selected', '');
    instructionOption.innerText = 'Select Product';
    selectElements.appendChild(instructionOption);

    // Iterate over products and add create option elements
    products.forEach((product) => {
      allProducts[product.name] = product.price;
      const productEl = document.createElement('option');
      productEl.value = product.name;
      productEl.innerText = product.name;
      selectElements.appendChild(productEl);
    });

    // Add all products to form selector
    const productSelector = document.getElementById('product-selector');
    productSelector.replaceChildren(selectElements);

    // Initialize Materialize Form Selector
    const formSelectors = document.querySelectorAll('select');
    M.FormSelect.init(formSelectors);
  } catch (err) {
    console.error(err.message);
  }
}

populateModalProducts();

const productForm = document.querySelector('#add-product-form');
productForm.addEventListener('submit', (e) => {
  e.preventDefault();
  const errorEl = document.querySelector('#add-product-modal .error');
  const productName = productForm['product-selector'].value;
  const quantity = parseInt(productForm['product-quantity'].value, 10);
  if (!quantity || !productName) {
    errorEl.innerText = 'All fields must contain valid values.';
    return;
  }
  orderProducts[productName] = {
    quantity,
    price: parseFloat(allProducts[productName].value) / 100,
  };
  console.log(orderProducts);
  const modal = document.querySelector('#add-product-modal');
  M.Modal.getInstance(modal).close();
  populateOrderProducts();
  productForm.reset();
  errorEl.innerText = '';
});

const timepickers = document.querySelectorAll('.timepicker');
M.Timepicker.init(timepickers);

const datepickers = document.querySelectorAll('.datepicker');
M.Datepicker.init(datepickers);

const modals = document.querySelectorAll('.modal');
M.Modal.init(modals);

// Do after filled with product options

const orderForm = document.getElementById('order-form');
orderForm.addEventListener('submit', async (e) => {
  e.preventDefault();
  const order = {
    type: 'custom',
    firstName: orderForm['first-name'].value,
    lastName: orderForm['last-name'].value,
    email: orderForm.email.value || '',
    phone: orderForm.phone.value || '',
    pickupDate: orderForm['pickup-date'].value,
    pickupTime: orderForm['pickup-time'].value,
  };
  const address = orderForm.address.value;
  const city = orderForm.city.value;
  const state = orderForm.state.value;
  const zip = orderForm['zip-code'].value;
  if (address && city && state && zip) {
    order.address = address;
    order.city = city;
    order.state = state;
    order.zip = zip;
  }
  const products = [];
  const productKeys = Object.keys(orderProducts);
  productKeys.forEach((key) => {
    products.push({
      name: key,
      price: orderProducts[key].price,
      quantity: orderProducts[key].quantity,
    });
  });
  order.products = products;
  const details = orderForm.details.value;
  if (details) order.details = details;
  try {
    e.stopPropagation();
    if (!orderId) await addDoc(ordersColRef, order);
    else await updateDoc(doc(ordersColRef, orderId), order);
    console.log('orderpage');
    window.location.assign(`/order.html?orderId=${orderId}`);
  } catch (err) {
    console.error(err.message);
  }
});

document
  .getElementById('delete-button')
  .addEventListener('click', async (e) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      if (orderId) await deleteDoc(doc(ordersColRef, orderId));
      window.location.assign('/index.html');
    } catch (err) {
      console.log(err.message);
    }
  });

async function loadOrder() {
  try {
    const snapshot = await getDoc(doc(ordersColRef, orderId));
    const order = snapshot.data();
    document.getElementById('first-name').value = order.firstName;
    document.getElementById('last-name').value = order.lastName;
    document.getElementById('email').value = order.email;
    document.getElementById('phone').value = order.phone;
    document.getElementById('address').value = order.address;
    document.getElementById('city').value = order.city;
    document.getElementById('state').value = order.state;
    document.getElementById('zip-code').value = order.zip;
    document.getElementById('pickup-date').value = order.pickupDate;
    document.getElementById('pickup-time').value = order.pickupTime;
    document.getElementById('details').value = order.details;
    order.products.forEach((product) => {
      orderProducts[product.name] = {
        quantity: product.quantity,
        price: product.price,
      };
    });
    populateOrderProducts();
    const labels = document.querySelectorAll('#order-form label');
    labels.forEach((label) => {
      label.classList.add('active');
    });
  } catch (err) {
    console.log(err);
  }
}
if (orderId) loadOrder();
